import type { AnswerT } from '../../..';
import type { CastedValue, ResolvedValues } from '../../type/common/types';
import type { ImageAnnotationResolver } from '../../type/image-resolver';
import type { QAAnnotationLabelAnswersInput } from '../../type/qa-engine';
import { QaCheckError, QaCheckErrorCode } from '../../utils/error';
import { castToRequiredType } from '../common/cast';
export const resolveImageData = (annotationResolver: ImageAnnotationResolver, annotationLabelAnswers: QAAnnotationLabelAnswersInput[]): QaCheckError | ResolvedValues<'ANNOTATION' | 'TASK_QUESTIONNAIRE'> => {
  const label = annotationResolver.filter.label;
  const annotationsWithSelectedLabel = annotationLabelAnswers.filter(a => a.labelTitle === label);
  if (annotationsWithSelectedLabel.length === 0) {
    return [];
  }
  const allResolvedData: ResolvedValues<'ANNOTATION' | 'TASK_QUESTIONNAIRE'> = [];
  for (const annotation of annotationsWithSelectedLabel) {
    const answerContexts: AnswerT[] = [];
    if (annotation.answers) {
      answerContexts.push(annotation.answers);
    }
    for (const span of annotation.dynamicAnswers ?? []) {
      answerContexts.push(span.answers);
    }
    for (const answers of answerContexts) {
      const resolved = getResolveDataFromAnswers(annotationResolver, answers);
      if (resolved instanceof QaCheckError && resolved.code === QaCheckErrorCode.missingFields) {
        continue;
      }
      if (resolved instanceof QaCheckError) {
        return resolved;
      }
      allResolvedData.push({
        values: resolved,
        metadata: {
          type: 'ANNOTATION',
          id: annotation.id
        }
      });
    }
  }
  return allResolvedData;
};
const getResolveDataFromAnswers = (annotationResolver: ImageAnnotationResolver, answers: AnswerT) => {
  const resolvedData = Object.entries(annotationResolver.resolve).reduce<{
    [subResolver: string]: CastedValue;
  } | QaCheckError>((accumulatedValues, [subAlias, resolver]) => {
    if (accumulatedValues instanceof QaCheckError) {
      return accumulatedValues;
    }
    switch (resolver.extract) {
      case 'ANSWER_VALUES':
        {
          const questionId = resolver.questionId;
          const questionAnswers = answers?.[questionId]?.answers;
          if (!questionAnswers) {
            return new QaCheckError('No answers found for configured question id', QaCheckErrorCode.missingFields);
          }
          const supportedAnswers = questionAnswers.filter(answer => {
            return typeof answer === 'string';
          });
          const destructuredAnswers = supportedAnswers.length === 1 ? supportedAnswers[0] ?? '' : supportedAnswers;
          const castedAnswer = castToRequiredType(resolver.cast, destructuredAnswers);
          accumulatedValues[subAlias] = castedAnswer;
          return accumulatedValues;
        }
      case 'AREA':
        {
          return new QaCheckError('Area is unimplemented.', QaCheckErrorCode.unimplemented);
        }
    }
  }, {});
  return resolvedData;
};